import PropTypes from 'prop-types';

export const maxTotalSize = 9437184; // 9MB
export const maxFileSize = 3145728; // 3MB

export const bytesToMB = (bytes) => (bytes / (1024 * 1024)).toFixed(2);

export const externalObject = PropTypes.shape({
  EventExternalObjectId: PropTypes.number.isRequired,
  ExternalObjectKeyGuid: PropTypes.string.isRequired,
  SourceDescription: PropTypes.string.isRequired,
  RelevanceDescription: PropTypes.string.isRequired,
  OriginalObjectName: PropTypes.string.isRequired,
  ObjectSizeBytes: PropTypes.number.isRequired,
  EventId: PropTypes.number.isRequired,
  EventTypePropertyId: PropTypes.number.isRequired,
  ConcurrencyControlNumber: PropTypes.number.isRequired,
  CreateTimestamp: PropTypes.string.isRequired,
  LastUpdateTimestamp: PropTypes.string.isRequired,
  CreateUserDisplayName: PropTypes.string.isRequired,
  LastUpdateUserDisplayName: PropTypes.string.isRequired,
});
